import {SsrContextData} from '@shared/frontends/ssr_context';

export function isHoobiizHost({host}: SsrContextData): boolean {
  return host.includes('hoobiiz') || host.includes('youpiiz');
}
